import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { useDarkMode } from '../contexts/DarkModeContext';

const SAFE_HREF_RE = /^(https?:|mailto:|tel:|\/|#)/i;
const sanitizeHref = (href) => (href && SAFE_HREF_RE.test(href) ? href : '#');


const ChatTypingIndicator = ({ statusMessage }) => {
  const { isDarkMode } = useDarkMode();

  // Avatar styles
  const avatarClass = isDarkMode
    ? 'h-9 w-9 rounded-full flex items-center justify-center font-semibold text-white bg-gradient-to-br from-cyan-500 to-sky-600 border border-slate-700'
    : 'h-9 w-9 rounded-full flex items-center justify-center font-semibold text-white bg-gradient-to-br from-sky-400 to-blue-500 border border-slate-200 shadow';

  // Typing bubble styles
  const bubbleClass = isDarkMode
    ? 'px-4 py-3 rounded-2xl bg-slate-800 border border-slate-700 shadow-sm'
    : 'px-4 py-3 rounded-2xl bg-white border border-slate-200 shadow';

  // Dot color
  const dotClass = isDarkMode
    ? 'h-2 w-2 rounded-full bg-sky-400 animate-typing'
    : 'h-2 w-2 rounded-full bg-blue-400 animate-typing';

  return (
    <div className="w-full px-3 py-2">
      <div className="flex items-start gap-3 max-w-[95%]">
        {/* Avatar */}
        <div className="flex-shrink-0">
          <div className={avatarClass}>
            D
          </div>
        </div>
        {/* Typing bubble */}
        <div className={bubbleClass}>
          {statusMessage ? (
            <div className="flex items-center gap-3">
              <div className={`text-sm whitespace-pre-wrap break-words ${
                isDarkMode ? 'text-slate-200' : 'text-gray-700'
              }`}>
                <ReactMarkdown
                  remarkPlugins={[remarkGfm]}
                  components={{
                    a: ({ href, children, ...props }) => (
                      <a href={sanitizeHref(href)} target="_blank" rel="noopener noreferrer" {...props}>{children}</a>
                    ),
                  }}
                >
                  {statusMessage}
                </ReactMarkdown>
              </div>
              <div className="flex items-center gap-1 flex-shrink-0">
                <span className={dotClass + ' delay-0'} />
                <span className={dotClass + ' delay-150'} />
                <span className={dotClass + ' delay-300'} />
              </div>
            </div>
          ) : (
            /* Horizontal typing dots */
            <div className="flex items-center gap-2">
              <span className={dotClass + ' delay-0'} />
              <span className={dotClass + ' delay-150'} />
              <span className={dotClass + ' delay-300'} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

ChatTypingIndicator.propTypes = {
  statusMessage: PropTypes.string,
};

export default ChatTypingIndicator;
